export const ingredientTypes = ['GRAIN', 'HOPS', 'MALT', 'YEAST', 'MISC'];
export const measurementTyes = ['KG', 'G', 'MG', 'L', 'ML'];
export const tankTypes = ['BREW_KEG', 'BREW_TANK', 'BRITE_TANK', 'UNI_TANK'];
export const tankStatuses = ['EMPTY', 'IN_USE', 'REQUIRES_CLEANING', 'UNAVAILABLE'];
export const transferTypes = ['TANK', 'VESSEL', 'LOCATION', 'DRY_HOP', 'CLARIFICATION'];



// WEBPACK FOOTER //
// ./src/constants/index.js